var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9577 2.83325C9.13768 2.83325 2.79102 9.17992 2.79102 16.9999C2.79102 24.8199 9.13768 31.1666 16.9577 31.1666C24.7777 31.1666 31.1243 24.8199 31.1243 16.9999C31.1243 9.17992 24.7918 2.83325 16.9577 2.83325ZM22.1 9.9V19.7C22.1 21.4 20.7 22.8 19 22.8C17.3 22.8 15.9 21.4 15.9 19.7C15.9 18 17.3 16.6 19 16.6C19.5 16.6 19.9 16.7 20.3 16.9V12.3L13.7 13.6V21.3C13.7 23 12.3 24.4 10.6 24.4C8.9 24.4 7.5 23 7.5 21.3C7.5 19.6 8.9 18.2 10.6 18.2C11.1 18.2 11.5 18.3 11.9 18.5V11.2L22.1 9.9Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicMenu);
export default __webpack_public_path__ + "static/media/music-menu.a7f9564f5773875a34e5c83e30311e3c.svg";
export { ForwardRef as ReactComponent };